import { makeStyle } from '../../utils';
import { rowCenter, secondary, secondaryOutline, columnCenter, overline } from '../../resources/styles';

const styles = {};

styles['container'] = makeStyle([rowCenter, { width: 'fit-content' }]);

styles['item_container'] = makeStyle({ width: 137, height: 137, borderRadius: 2, marginRight: 16, flexShrink: 0 });

styles['add_container'] = makeStyle([columnCenter, secondary, {
    backgroundColor: secondaryOutline.color, border: `1px dashed ${secondary.color}`, justifyContent: 'center',
    padding: 24, boxSizing: 'border-box',
}]);

styles['add_text'] = makeStyle([overline, { marginTop: 4, letterSpacing: '0.4px' }]);

export default styles;